// hooks
import { useStore } from '@/store';
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { TutorialVideos } from '@/vue3/api/models';

export const useTutorialVideoService = () => {
    // hooks
    const { apiUrl, bunnyNetBaseUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getVideosDescription = async (): Promise<TutorialVideos[]> => {
        const res = await axios.get(`${apiUrl}/tutorial-video`);
        return res.data;
    };

    const getVideoURL = (vidNum: number): string => {
        return `${bunnyNetBaseUrl}/tutorial_videos/${vidNum}.mp4`;
    };

    const checkVideoExists = async (url: string): Promise<boolean> => {
        try {
            const response = await fetch(url, { method: 'HEAD' });
            return response.ok;
        } catch (error) {
            return false;
        }
    };

    return { getVideosDescription, getVideoURL, checkVideoExists };
};
